import React, { useEffect } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";

import Loader from "../../../Components/Global/Loader";

import { useAuth } from "../../../Context/AuthContext";
import Paginations from "../../../hooks/Paginations";
import useAuthentication from "../../../hooks/useAuthentication";
import useSearchListPagination from "../../../hooks/useSearchListPagination";

function RevenueAccountantProfile({ allowedRoles }) {

  const { allowLoading } = useAuthentication(allowedRoles)


  // const {
  //   isKeyPress,
  //   setisKeyPress,
  //   Count,
  //   setCount,
  //   setsearchKey,
  //   searchKey,
  //   setRecord,
  //   record,
  //   setPages,
  //   pages,

  //   totallength,
  //   setTotallength,
  //   paginationLoading,
  //   setLoadingPagination,
  //   handleNextbtn,
  //   handlePrevbtn,
  //   PageShowFunc,
  //   SearchApi,
  //   allData,
  //   DataListApi ,
  //   apiurl,
  //   SearchListApi


  // } = useSearchListPagination();


  const {
    setisKeyPress,
    Count,
    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
    totallength,
    paginationLoading,
    handleNextbtn,
    handlePrevbtn,
    PageShowFunc,
    SearchListApi,
    allData,
    PagesFunc,
    responseData,
  } = useSearchListPagination();


  useEffect(() => {
   
        SearchListApi(`revenue`);
      
   
  }, [searchKey, record, pages]);


  // useEffect(() => {

    
  //     SearchApi("accountant_building_name");
   
  // }, [searchKey, record, pages]);









  

 

  const { designation } = useAuth();



  return (
    <>
      <DashboardLayouts>
        {(paginationLoading || allowLoading) && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/dashboard"
                  : `/${designation}dashboard`.toLowerCase()
              }
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Dashboard</h3>
            </Link>
          </div>
        </div>
        {/* ----- Body Content ---- */}
        <div className="list-data">
          <h1 className="heading-text mb-4">View All Revenue</h1>
          {/* --- Data filter --- */}
          <div className="data-filters d-flex justify-content-between align-items-center mb-4">
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={record}
                  name="record"
                  onChange={(event) => {
                    setRecord(event.target.value);
                    setPages(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                </select>
              </form>

              <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
            </div>

            {/* <div className="form search-bar1 ms-3">
              <input
                type="search"
                className="form-control search-new"
                placeholder="search building name"
                aria-label="search"
                aria-describedby="search"
                name="buildingSearch"
                value={buildingSearch}
                onKeyDown={(e) => setisKeyPress(false)}
                onChange={(e) => setSearchBuilding(e.target.value.trimStart())}
              />
              <button
                className="search-btn fa-solid fa-magnifying-glass"
                type="submit"
                disabled={buildingSearch.trimStart() == ""}
                onClick={(e) => SearchBuilding(e)}
              >
                <FaSearch className="m-0 " color="#bebebe" />
              </button>
            </div> */}
          </div>
        </div>
        <div className="w-100 table-content overflow-auto">
          <table className="w-100">
            <thead>
              <tr>






                <th>SL No</th>
                <th>Tenant Name</th>
                <th>Building Name</th>
                <th>Unit Name</th>
                {/* <th>Total Outstanding</th>
                <th>Collected Amount </th>
                <th>Date of Collection</th>
                <th>Balance</th>
                <th>Transection ID</th> */}

                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {allData?.length > 0 ? (
                allData?.map((items, i) => {
                  return (
                    <tr key={i} className={`border-b`}>
                      <td className="text-center">
                        {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                      </td>
                      <td className="">{items?.tenant_name
                      }   </td>
                      <td className="">{items?.building_name}</td>
                      <td className="">{items?.unit_name}</td>

                      {/* <td className="">{items?.Total
}</td>
                    
                          <td className="text-center">{items?.Collected_Amount
}</td>
                          <td className="">{moment(items?.Payment_date).format('L')}</td>
                      
                                <td className="">{items.balance
}</td>

                      <td className="text-center"> {items?.transaction_id

}</td> */}

                      <td className="tex-center">
                        <ul className="table-icon d-flex justify-center text-center">
                          {/* <li  className="tex-center">
                          
 <button className="btn btn-outline-primary" >Print</button>
                                      
                          </li> */}
                          <li className="tex-center">
                            <Link
                              to={designation == "Owner" ? `/owner/revenue-details/${items?.tenant_id}` : `/${designation?.toLowerCase()}/revenue-details/${items?.tenant_id}`}
                            >
                              <FaEye className="view-icon" color="black" />
                            </Link>
                          </li>
                          {/* <li>
                                                        <Link to={`/addbuilding/${items?.id}`}>
                                                            <FaPen
                                                                className="table-edit-icon ml-5 "
                                                                color="black"
                                                            />
                                                        </Link>
                                                    </li> */}
                        </ul>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* {Count > 5 && totallength.length > 1 ? (
          <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
            <button
              onClick={handlePrevbtn}
              disabled={pages == 1 ? true : false}
            >
              <GrFormPrevious className="pagebutton" color="#bebebe" />
            </button>
            <ul className="d-flex">
              {allData.length > 0 && PageShowFunc}
            </ul>
            <button
              onClick={handleNextbtn}
              disabled={pages == PageShowFunc.length ? true : false}
            >
              <GrFormNext className="pagebutton" color="#bebebe" />
            </button>
          </div>
        ) : null} */}

        {/* <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
          <button onClick={handlePrevbtn} disabled={pages == 1 ? true : false}>
            <GrFormPrevious className="pagebutton" color="#bebebe" />
          </button>
          <ul className="d-flex">
            <li>
              <button name="pages" className="active">
                1
              </button>
            </li>
            <li>
              <button name="pages" className="active">
                2
              </button>
            </li>
            <li>
              <button name="pages" className="active">
                3
              </button>
            </li>
          </ul>

          <button
            onClick={handleNextbtn}
            disabled={pages == PageShowFunc.length ? true : false}
          >
            <GrFormNext className="pagebutton" color="#bebebe" />
          </button>
        </div> */}


{Count > 5 && totallength.length > 1 && (
          <Paginations
            onPageChange={PagesFunc}
            currentPage={pages}
            totalPages={totallength.length}
          />
        )}
      </DashboardLayouts>
    </>
  );
}

export default RevenueAccountantProfile;
